<template>
  <component
    :is="isMegaMenuMobile ? LazyCmsMegaMenuL2Mobile : LazyCmsMegaMenuL2Desktop"
    v-bind="{ content }"
    @click="handleClick"
    @expand="handleClickCollapse"
  />
</template>

<script lang="ts" setup>
import type { MenuItem } from '#types/components/cms/mega-menu'
import { LazyCmsMegaMenuL2Desktop, LazyCmsMegaMenuL2Mobile } from '#components'
import { MegaMenuL1ContextKey, MegaMenuL2ContextKey, MegaMenuMobileContextKey } from '#content/contexts/megamenu'

const props = defineProps<{
  content: MenuItem
}>()

const { $gtm } = useNuxtApp()

const eventLabel = props.content.delocalizedTracking || props.content.name

provide(MegaMenuL2ContextKey, {
  title: eventLabel,
  featured: props.content.menuStyle === 'featured',
})

const l1 = inject(MegaMenuL1ContextKey)
const isMegaMenuMobile = inject(MegaMenuMobileContextKey, false)

const handleClick = () => $gtm.push('topNav.onClickTopNavLink', `${l1} | ${eventLabel}`)
const handleClickCollapse = () => $gtm.push('topNav.onClickMobileMenuSection', `${l1} | ${eventLabel}`)
</script>
